import type { FireIconProps } from './types';

export default function HazmatPlacard({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Diamond placard */}
      <path d="M12 2l10 10-10 10L2 12z" />
      {/* Hazard symbol — trefoil-like */}
      <circle cx="12" cy="11" r="1.5" />
      <path d="M12 6a4 4 0 0 1 3.5 5" />
      <path d="M12 6a4 4 0 0 0-3.5 5" />
      <path d="M8.5 11a4 4 0 0 0 3.5 5" />
      <path d="M15.5 11a4 4 0 0 1-3.5 5" />
      {/* UN number line */}
      <line x1="8" y1="18" x2="16" y2="18" />
    </svg>
  );
}
